import { render, staticRenderFns } from "./ItCardList.vue?vue&type=template&id=0626d873&scoped=true&"
import script from "./ItCardList.vue?vue&type=script&lang=js&"
export * from "./ItCardList.vue?vue&type=script&lang=js&"
import style0 from "./ItCardList.vue?vue&type=style&index=0&id=0626d873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626d873",
  null
  
)

export default component.exports